"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginTypes = void 0;
var OriginTypes;
(function (OriginTypes) {
    OriginTypes["UserAction"] = "user_action";
    OriginTypes["DirectLink"] = "direct_link";
})(OriginTypes = exports.OriginTypes || (exports.OriginTypes = {}));
